// nChoixCategorieOffre.vue

<template>
    <v-container>
       <v-row>
          <v-col cols='8'><h1>Catégories d'offres</h1></v-col>
          <v-col cols='4' class="text-right"><v-btn :to="$root.menu.homePage">Retour</v-btn></v-col>
       </v-row>
      <v-divider></v-divider>
      <br/>
      
      <p class="para">Veuillez sélectionner la catégorie de l'offre souhaitée :</p>
       
    <v-col cols="12" class='offres'>
      <v-row justify="center" v-if="$root.user.type=='VAD'">

        <v-col cols="12" sm="6" md="6"  v-if="$root.user.type=='VAD'">
          <v-card color="#871d81" dark min-height="140" shaped to="/souscription/offresbox/eligibilite/adresse">
            <v-card-title class="headline">Offres BOX</v-card-title>
            <v-card-subtitle>Offres Fibre, câble, Box 4G, ADSL</v-card-subtitle>
          </v-card>
        </v-col>
       
      </v-row>

      <v-row justify="center" v-if="$root.user.type=='DEV'">
        <v-col cols="12" sm="6" md="6" >
          <v-card color="#871d81" dark min-height="140" shaped to="/souscription/offresbox/eligibilite/adresse">
            <v-card-title class="headline">Eligibilité</v-card-title>
            <v-card-subtitle>Offres Fibre, câble, Box 4G, ADSL</v-card-subtitle>
          </v-card>
        </v-col>

        <!--<v-col cols="6" sm="12" md="6">
           <v-card color="secondary" dark min-height="140" shaped to="/souscription/offresmobile/choixoffreoption">
            <v-card-title class="headline">Forfaits mobile</v-card-title>
            <v-card-subtitle>Offres mobile</v-card-subtitle>
          </v-card>
        </v-col>-->


      </v-row>

      <v-row justify="center" v-if="$root.user.type=='COM'">
        <v-col cols="12" sm="6" md="6" >
          <v-card color="#871d81" dark min-height="140" shaped to="/souscription/offresbox/eligibilite/adresse">
            <v-card-title class="headline">Eligibilité</v-card-title>
            <v-card-subtitle>Offres Fibre, câble, Box 4G, ADSL</v-card-subtitle>
          </v-card>
        </v-col>

        <!--<v-col cols="6" sm="12" md="6">
           <v-card color="secondary" dark min-height="140" shaped to="/souscription/offresmobile/choixoffreoption">
            <v-card-title class="headline">Forfaits mobile</v-card-title>
            <v-card-subtitle>Offres mobile</v-card-subtitle>
          </v-card>
        </v-col>-->


      </v-row>

      <v-row justify="center" v-if="$root.user.type=='LPM'">
        <v-col cols="12" sm="6" md="6" >
          <v-card color="#871d81" dark min-height="140" shaped to="/souscription/offresbox/eligibilite/adresse">
            <v-card-title class="headline">Eligibilité</v-card-title>
            <v-card-subtitle>Offres Fibre, câble, Box 4G, ADSL</v-card-subtitle>
          </v-card>
        </v-col>

        <!--<v-col cols="6" sm="12" md="6">
           <v-card color="secondary" dark min-height="140" shaped to="/souscription/offresmobile/choixoffreoption">
            <v-card-title class="headline">Forfaits mobile</v-card-title>
            <v-card-subtitle>Offres mobile</v-card-subtitle>
          </v-card>
        </v-col>-->


      </v-row>

      <v-row justify="center" v-if="$root.user.type=='TLV'">

        <v-col cols="6" sm="12" md="6">
           <v-card color="#871d81" dark min-height="140" shaped to="/souscription/offresbox/eligibilite/adresse">
            <v-card-title class="headline">Eligibilité</v-card-title>
            <v-card-subtitle>Tester l'éligibilité</v-card-subtitle>
          </v-card>
        </v-col>

        

      </v-row>

      <v-row justify="center" v-if="$root.user.type=='DGL'">

        <v-col cols="6" sm="12" md="6">
           <v-card color="#570674" dark min-height="140" shaped to="/souscription/offresmobile/choixoffreoption">
            <v-card-title class="headline">Forfaits mobile</v-card-title>
            <v-card-subtitle>Offres mobile</v-card-subtitle>
          </v-card>
        </v-col>

        

      </v-row>
    </v-col>

    </v-container>
</template>
<script>
export default {
  data: () => ({
  }),
  mounted: function () {
      this.$root.initSouscription();

  },
  methods: {
    
  }
}
</script>

<style>
   .offres {
      margin-top:40px;
   }
</style>